<template>
  <lang-set />
</template>

<script>
import LangSet from "../../components/lang-set/LangSet";

export default {
  name: "LangSetEdit",
  components: {LangSet},
}
</script>

<style lang="scss" scoped>

</style>
